import AuditPage from './AuditPage'

const routes: IRoute[] = [
	{
		path: '/AuditPage',
		component: AuditPage,
		name: '角色管理',
	},
]

export default routes



// WEBPACK FOOTER //
// ./src/modules/System/index.ts